/* eslint-disable no-undef */
if (window.__VUE_APP_PUBLIC_PATH__) {
  __webpack_public_path__ = window.__VUE_APP_PUBLIC_PATH__
}

import createApp from './src/app.js'

const { app, router, store } = createApp()

// Restore server-side state
if (window.__INITIAL_STATE__) {
  store.replaceState(window.__INITIAL_STATE__)
}

router.onReady(() => {
  // Client-side route navigation - call asyncData on new components
  router.beforeResolve(async (to, from, next) => {
    const matched = router.getMatchedComponents(to)
    const prevMatched = router.getMatchedComponents(from)

    // Only handle newly activated components
    let diffed = false
    const activated = matched.filter((c, i) => {
      return diffed || (diffed = prevMatched[i] !== c)
    })

    if (activated.length) {
      try {
        await Promise.all(
          activated.map((Component) => {
            if (Component.asyncData) {
              return Component.asyncData({
                store,
                route: to,
              })
            }
          }),
        )
      } catch (err) {
        console.error('Client asyncData error:', err)
      }
    }
    next()
  })

  app.$mount('#app')
})
